// extracted by mini-css-extract-plugin
export var body = "_c1-0";
export var sectionHeader = "_c1-4";
export var shortcutColumns = "_c1-2";
export var shortcutList = "_c1-1";
export var shortcutSection = "_c1-3";